"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImmersive3DModelStencil = exports.immersive3DModelStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.immersive3DModelStencilDefinition = {
    view: {
        label: '3D Model',
        category: 'game',
        group: 'Misc.',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'title',
                    'subheading',
                    'teaser',
                    'immersive-3d-model-essence',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'epg-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'social-media-image',
                            'featured-video',
                            'geolocation',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'standalone',
                            'no-monetization',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-photographers',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.contentClassificationTermsPropertyDefinition.name]: properties_1.contentClassificationTermsPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: {
            ...properties_1.disciplinesPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['discipline'],
                },
            ],
        },
        [properties_1.epgTitlePropertyDefinition.name]: properties_1.epgTitlePropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: {
            ...properties_1.featuredVideoPropertyDefinition,
            view: {
                label: 'Featured video',
                hint: 'Used to represent the content piece on collection pages.',
                hintAdditional: 'If there is a preview clip available it will be automatically embedded here after publishing. Please notice it may take a few minutes upon publishing before the preview clip will show.',
            },
        },
        [properties_1.geolocationPropertyDefinition.name]: properties_1.geolocationPropertyDefinition,
        [properties_1.immersive3DModelEssencePropertyDefinition.name]: properties_1.immersive3DModelEssencePropertyDefinition,
        [properties_1.noMonetizationPropertyDefinition.name]: properties_1.noMonetizationPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialMediaImagePropertyDefinition.name]: properties_1.socialMediaImagePropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.subheadingPropertyDefinition.name]: properties_1.subheadingPropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagPhotographersPropertyDefinition.name]: properties_1.tagPhotographersPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: properties_1.teaserPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: {
            ...properties_1.titlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'maxLength',
                    argument: 75,
                },
            ],
        },
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: ['rbtv_temporary'],
    name: 'immersive-3d-model',
};
const isImmersive3DModelStencil = (stencil) => {
    return stencil.name === exports.immersive3DModelStencilDefinition.name;
};
exports.isImmersive3DModelStencil = isImmersive3DModelStencil;
//# sourceMappingURL=data:application/json;base64,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